document.addEventListener('DOMContentLoaded', () => {


    function fixHeadingStructureInHome() {
        if(window.location.pathname === '/pages/locations' || window.location.pathname === "/") {
            
            //We added DIVs to the first one index0 because in the view we don't need h tags for the first text-image section
            document.querySelectorAll(".image-with-text__text-item").forEach((element, index) => {
                        const title = element.querySelector("h1");
                        if(title) {
                            const newTitle = index === 0 ? document.createElement("div") : document.createElement("h2");
                            newTitle.innerText = title.innerText;
                            newTitle.className = title.className;

                            const subtitle = element.querySelector("h2");
                            if(subtitle) {
                                const newSubtitle = index === 0 ? document.createElement("div") : document.createElement("h3");
                                newSubtitle.innerText = subtitle.innerText;
                                newSubtitle.classList.add("h2");
                                subtitle.replaceWith(newSubtitle);
                            }
                            
                            title.replaceWith(newTitle);
                        }
                    });
        }
    }

    fixHeadingStructureInHome();




    //Hide spacers from screen readers
    document.querySelectorAll("br, hr")
                .forEach(element => element.setAttribute("aria-hidden", "true"));


    //Find email links in FOOTER and set aria-label with the h2 title
    document.querySelectorAll(".footer-block, .image-with-text").forEach(item => {
        const title = item.querySelector("h2");
        const mailLink = item.querySelector('a[href^="mailto:"]');
        if(mailLink && title) {
            mailLink.setAttribute("aria-label", `Email ${title.innerText}`);
        }
    });

    //Find phone numbers links in FOOTER and set aria-label with the h2 title
    document.querySelectorAll(".footer-block, .image-with-text").forEach(item => {
        const title = item.querySelector("h2");
        const phoneLink = item.querySelectorAll('a[href^="tel:"]').forEach(link => {
            if(link) {
                link.setAttribute("aria-label", `Call ${title.innerText}: ${link.innerText}`);
            }
        });
    });

    function toggleHamburguerMenu() {
        const menuContainer = document.querySelector("#hamburguer-container");
        if(menuContainer) {
            const menuBtn = menuContainer.querySelector("summary");
            if(menuBtn) {
                menuBtn.addEventListener('click', () => {
                    if(menuContainer.getAttribute("role") === 'none') {
                        menuContainer.setAttribute("role", "dialog");
                    } else {
                        menuContainer.setAttribute("role", "none");
                    }
                });
            }
        }
    }

    toggleHamburguerMenu();

    //This should only run on the product's page
    function addAriaHiddenToShopifyHiddenContent() {
        if (window.location.pathname.startsWith("/products/")) {
            const items = document.querySelectorAll("shopify-payment-terms");
            items.forEach(element => {
                const container = element.shadowRoot.querySelector("#prequalAmountContainer");
                if(container) {
                    Array.from(container.children).forEach(element => {
                        element.setAttribute("tabindex", "-1");
                        element.setAttribute("aria-hidden", "true");
                    });
                }
            });
        }
    }

    addAriaHiddenToShopifyHiddenContent();

    function replaceListSemanticsToDivHeroSlider() {
        if(window.location.pathname === "/") {
            const list = document.querySelector(".multicolumn-list");
            if(list) {
                list.querySelectorAll("li").forEach(item => {
                    const newItem = document.createElement("div");
                    for (let attr of item.attributes) {
                        newItem.setAttribute(attr.name, attr.value);
                    }
                    newItem.innerHTML = item.innerHTML;
                    item.replaceWith(newItem);
                });
                const newListDiv = document.createElement("div"); 
                for (let attr of list.attributes) {
                    newListDiv.setAttribute(attr.name, attr.value);
                }
                newListDiv.innerHTML = list.innerHTML;
                list.replaceWith(newListDiv);
            }
        }

    }

    replaceListSemanticsToDivHeroSlider();


    //We need to remove if there are more than 1 h1 and we wait 3 sec because we wanna make your everything loaded correctly
    function changeH1IfAlreadyExist() {
        const titles = document.querySelectorAll("h1:not(.cart-notification__heading)");
        if(titles.length < 2) return;
        document.querySelectorAll(".image-with-text__grid h1").forEach(item => {
            const newTitle = document.createElement("h2");
            newTitle.className = item.className;
            newTitle.innerText = item.innerText;
            newTitle.classList.add("h1");
            item.replaceWith(newTitle);
        });
    }

    setTimeout(() => {
        changeH1IfAlreadyExist();
    }, 3000);

    function listenToBtns() {
        const slider = document.querySelector("slider-component");
        if(!slider) return;
        const buttons = slider.querySelectorAll(".slider-buttons button");

        if(buttons.length > 1) {
            buttons[0].addEventListener('click', () => updateAriaLabelBtns(slider, buttons));
            buttons[1].addEventListener('click', () => updateAriaLabelBtns(slider, buttons));
        }
    }

    function updateAriaLabelBtns(parent, buttons) {
        setTimeout(() => {
            const current = parent.querySelector(".slider-counter--current").innerText;
            buttons[0].setAttribute("aria-label",`Go to page #${+current - 1}`);
            buttons[1].setAttribute("aria-label", `Go to page #${+current + 1}`);
        }, 300);
    }

    listenToBtns();
});